import React from 'react'
import injectSheet from 'react-jss/lib/injectSheet'

const imageThumbnailStyles = {
  container: {
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }
}

const ImageSlideThumbnail = injectSheet(imageThumbnailStyles)(
  ({ classes, presentation, slide }) => {
    const image = slide.use_presentation_image
      ? presentation.image_url
      : slide.image.medium_url
    return (
      <div
        className={classes.container}
        style={{
          backgroundImage: `url("${image}")`
        }}
      />
    )
  }
)

export default ImageSlideThumbnail
